import React, { FC } from 'react';

import Paper from '@material-ui/core/Paper';

import { IEventItem } from '../../store/player/events/store';

import EventContent from './Components/EventContent/EventContent';

interface IProps {
  item?: IEventItem;
}

const NextEvent: FC<IProps> = props => {
  const { item } = props;

  return !!item ? (
    <div className={`next-event ${!item ? 'empty' : ''}`}>
      <Paper elevation={1} className="paper">
        <h4>My Next Event</h4>

        <EventContent item={item} />
      </Paper>
    </div>
  ) : (
    <></>
  );
};

export default NextEvent;
